import React from 'react';
import './index.less';

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  children: string | React.ReactNode;
}
export const RevxDiscTextItem: React.FC<Props> = ({ children, ...props }) => {
  return (
    <div {...props} className="disc-text-item">
      {children}
    </div>
  );
};
